import { makeAutoObservable, observable, action, runInAction } from "mobx";
import agent from "../api/agent";
import { RootStore } from "./rootStore";
import { toast } from "react-toastify";
import { ISellerForm, IChangeSellerState } from "../models/seller";
import { IList } from "../models/listOfValours";
import { showError } from "../util/errorTypeEnumsOptions";

export default class SellerStorage {
  rootStore: RootStore;
  constructor(rootStore: RootStore) {
    makeAutoObservable(this);
    this.rootStore = rootStore;
  }

  @observable sellers: ISellerForm[] = [];
  @observable seller: ISellerForm | null = null;
  @observable sellersOption: IList[] = [];
  @observable loadSeller = false;
  @observable loadData = false;

  @action newSeller = async (values: ISellerForm) => {
    this.rootStore.buttonLoadingStore.changeState();
    try {
      await agent.Seller.newSellert(values);
      toast.success("Vendedor creado satisfactoriamente.");
      this.rootStore.modalStore.closeModal();
      this.getSellers();
    } catch (error) {
      showError(error);
    }
    this.rootStore.buttonLoadingStore.changeState();
  };

  @action editSeller = async (values: ISellerForm) => {
    this.rootStore.buttonLoadingStore.changeState();
    try {
      await agent.Seller.editSellert(values);
      toast.success("Vendedor editado satisfactoriamente.");
      this.rootStore.modalStore.closeModal();
      this.getSellers();
    } catch (error) {
      showError(error);
    }
    this.rootStore.buttonLoadingStore.changeState();
  };

  @action changeSellerState = async (sellerChangeState: IChangeSellerState) => {
    try {
      const change = await agent.Seller.changeSellerState(sellerChangeState);
      if (change) {
        toast.success("Se ha cambiado el estado correctamente");
        this.getSellers();
      } else toast.error("UPS! No se pudo cambiar el estado");
    } catch (error) {
      showError(error);
    }
  };

  @action getSellerById = async (id: string) => {
    try {
      const res = await agent.Seller.getSellerById(id);
      runInAction(() => {
        this.seller = res;
        this.loadSeller = true;
      });
    } catch (error) {
      showError(error);
    }
  };

  @action getSellersOption = async () => {
    try {
      const sellers = await agent.Seller.getSellers();
      runInAction(() => {
        this.sellersOption = [];
        for (var key in sellers) {
          this.sellersOption.push({
            key: `${sellers[key].id}}`,
            text: `${sellers[key].identification}-${sellers[key].fullName}`,
            value: sellers[key].id,
          });
        }
      });
    } catch (error) {
      showError(error);
    }
  };

  @action getSellers = async () => {
    try {
      const sellers = await agent.Seller.getSellers();
      runInAction(() => {
        this.sellers = sellers;
      });
    } catch (error) {
      showError(error);
    }
    runInAction(() => {
      this.loadData = true;
    });
  };
}
